import { createSelector } from 'reselect';

// Base selectors
const getFormsState = (state) => state.forms;

// Claims form selectors
export const getClaimFormState = createSelector([getFormsState], (forms) => forms.claimForm);

export const getClaimFormData = createSelector([getClaimFormState], (claimForm) => claimForm.data);

export const getClaimFormStatus = createSelector(
  [getClaimFormState],
  (claimForm) => claimForm.status
);

export const getClaimFormIsSubmitting = createSelector(
  [getClaimFormState],
  (claimForm) => claimForm.isSubmitting
);

export const getClaimFormError = createSelector(
  [getClaimFormState],
  (claimForm) => claimForm.error
);

// Consultation form selectors
export const getConsultationFormState = createSelector(
  [getFormsState],
  (forms) => forms.consultationForm
);

export const getConsultationFormData = createSelector(
  [getConsultationFormState],
  (consultationForm) => consultationForm.data
);

export const getConsultationFormStatus = createSelector(
  [getConsultationFormState],
  (consultationForm) => consultationForm.status
);

export const getConsultationFormIsSubmitting = createSelector(
  [getConsultationFormState],
  (consultationForm) => consultationForm.isSubmitting
);

// Regret form selectors
export const getRegretFormState = createSelector([getFormsState], (forms) => forms.regretForm);

export const getRegretFormData = createSelector(
  [getRegretFormState],
  (regretForm) => regretForm.data
);

export const getRegretFormStatus = createSelector(
  [getRegretFormState],
  (regretForm) => regretForm.status
);

export const getRegretFormIsSubmitting = createSelector(
  [getRegretFormState],
  (regretForm) => regretForm.isSubmitting
);
